import { render, staticRenderFns } from "./FifthAdminComp.vue?vue&type=template&id=729f4dc2&"
import script from "./FifthAdminComp.vue?vue&type=script&lang=js&"
export * from "./FifthAdminComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports